import { useRef } from "react";
import classnames from "classnames";
import { useHistory, useLocation } from "react-router-dom";
import DefaultSelect from "../DefaultSelect";
import { TooltipContainer } from "@outplayed/tooltips";
import { TIER_LIST_ROLE_OPTIONS } from "@ugg/shared/query-params/filter-options/tier-lists/tier-list";
import { useTranslation } from "react-i18next";
import { FILTER_IS_NOT_DEFAULT_CLASSNAME } from "../FilterManager";
import { FilterSelect } from "@ugg/shared/interfaces/filter-manager.interface";

interface TierListRoleProps extends FilterSelect {
  className?: string;
  page: (typeof TIER_LIST_ROLE_OPTIONS)[number]["value"];
  defaultOption: (typeof TIER_LIST_ROLE_OPTIONS)[number];
  disableTooltip?: boolean;
  isMobile?: boolean;
}

export default function TierListRole(props: TierListRoleProps) {
  const tooltipRef = useRef<{ forceClose: Function }>({ forceClose: () => {} });
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const { className, page, defaultOption, disableTooltip, isMobile } = props;

  const formatOptionLabel = ({ value, label, img }: (typeof TIER_LIST_ROLE_OPTIONS)[number]) => {
    return (
      <div className="role-value">
        {img}
        <div style={{ marginLeft: "12px" }}>{t(label)}</div>
      </div>
    );
  };

  const onChange = (selected: (typeof TIER_LIST_ROLE_OPTIONS)[number]) => {
    history.push({
      pathname: selected.path,
      search: location.search,
    });
  };

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Role")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Role")}
          group={"role"}
          isMobile={isMobile}
          className={classnames("filter-select", {
            [FILTER_IS_NOT_DEFAULT_CLASSNAME]: defaultOption.value === page,
          })}
          options={TIER_LIST_ROLE_OPTIONS}
          onChange={onChange}
          value={page}
          formatOptionLabel={formatOptionLabel}
          width={110}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
}
